import {KiasDataRepresentationInterface} from "../types/responses/data-for-render";

const KIAS_COUNTRIES: KiasDataRepresentationInterface[] = [
    {
        "isn": 9436,
        "value": "Австралия"
    },
    {
        "isn": 9437,
        "value": "Австрия"
    },
    {
        "isn": 9438,
        "value": "Азербайджан"
    },
    {
        "isn": 9439,
        "value": "Албания"
    },
    {
        "isn": 9440,
        "value": "Алжир"
    },
    {
        "isn": 9441,
        "value": "Американское Самоа"
    },
    {
        "isn": 9442,
        "value": "Ангилья"
    },
    {
        "isn": 9443,
        "value": "Ангола"
    },
    {
        "isn": 9444,
        "value": "Андорра"
    },
    {
        "isn": 9445,
        "value": "Антарктида"
    },
    {
        "isn": 9446,
        "value": "Антигуа и Барбуда"
    },
    {
        "isn": 9447,
        "value": "Аргентина"
    },
    {
        "isn": 9448,
        "value": "Армения"
    },
    {
        "isn": 9449,
        "value": "Аруба"
    },
    {
        "isn": 9450,
        "value": "Афганистан"
    },
    {
        "isn": 9451,
        "value": "Багамы"
    },
    {
        "isn": 9452,
        "value": "Бангладеш"
    },
    {
        "isn": 9453,
        "value": "Барбадос"
    },
    {
        "isn": 9454,
        "value": "Бахрейн"
    },
    {
        "isn": 9455,
        "value": "Беларусь"
    },
    {
        "isn": 9456,
        "value": "Белиз"
    },
    {
        "isn": 9457,
        "value": "Бельгия"
    },
    {
        "isn": 9458,
        "value": "Бенин"
    },
    {
        "isn": 9459,
        "value": "Бермуды"
    },
    {
        "isn": 9460,
        "value": "Болгария"
    },
    {
        "isn": 9461,
        "value": "Боливия"
    },
    {
        "isn": 222504,
        "value": "Бонэйр, Синт-Эстатиус и Саба"
    },
    {
        "isn": 9462,
        "value": "Босния и Герцеговина"
    },
    {
        "isn": 9463,
        "value": "Ботсвана"
    },
    {
        "isn": 9464,
        "value": "Бразилия"
    },
    {
        "isn": 9465,
        "value": "Британская Территория в Индийском океане"
    },
    {
        "isn": 9466,
        "value": "Бруней-Даруссалам"
    },
    {
        "isn": 9467,
        "value": "Буркина-Фасо"
    },
    {
        "isn": 9468,
        "value": "Бурунди"
    },
    {
        "isn": 9469,
        "value": "Бутан"
    },
    {
        "isn": 9470,
        "value": "Вануату"
    },
    {
        "isn": 9593,
        "value": "Ватикан"
    },
    {
        "isn": 9623,
        "value": "Великобритания"
    },
    {
        "isn": 9471,
        "value": "Венгрия"
    },
    {
        "isn": 9472,
        "value": "Венесуэла"
    },
    {
        "isn": 9473,
        "value": "Виргинские Острова, Британские"
    },
    {
        "isn": 9474,
        "value": "Виргинские Острова, США"
    },
    {
        "isn": 9476,
        "value": "Вьетнам"
    },
    {
        "isn": 9477,
        "value": "Габон"
    },
    {
        "isn": 9478,
        "value": "Гаити"
    },
    {
        "isn": 9479,
        "value": "Гайана"
    },
    {
        "isn": 9480,
        "value": "Гамбия"
    },
    {
        "isn": 9481,
        "value": "Гана"
    },
    {
        "isn": 9482,
        "value": "Гваделупа"
    },
    {
        "isn": 9483,
        "value": "Гватемала"
    },
    {
        "isn": 9484,
        "value": "Гвинея"
    },
    {
        "isn": 9485,
        "value": "Гвинея-Бисау"
    },
    {
        "isn": 9486,
        "value": "Германия"
    },
    {
        "isn": 222600,
        "value": "Гернси"
    },
    {
        "isn": 9487,
        "value": "Гибралтар"
    },
    {
        "isn": 9488,
        "value": "Гондурас"
    },
    {
        "isn": 9489,
        "value": "Гонконг"
    },
    {
        "isn": 9490,
        "value": "Гренада"
    },
    {
        "isn": 9491,
        "value": "Гренландия"
    },
    {
        "isn": 9492,
        "value": "Греция"
    },
    {
        "isn": 9493,
        "value": "Грузия"
    },
    {
        "isn": 9494,
        "value": "Гуам"
    },
    {
        "isn": 9495,
        "value": "Дания"
    },
    {
        "isn": 222503,
        "value": "Джерси"
    },
    {
        "isn": 9496,
        "value": "Джибути"
    },
    {
        "isn": 9497,
        "value": "Доминика"
    },
    {
        "isn": 9498,
        "value": "Доминиканская Республика"
    },
    {
        "isn": 226935,
        "value": "Донецкая Народная Республика"
    },
    {
        "isn": 9499,
        "value": "Египет"
    },
    {
        "isn": 9500,
        "value": "Замбия"
    },
    {
        "isn": 9501,
        "value": "Западная Сахара"
    },
    {
        "isn": 9502,
        "value": "Зимбабве"
    },
    {
        "isn": 9503,
        "value": "Израиль"
    },
    {
        "isn": 9504,
        "value": "Индия"
    },
    {
        "isn": 9505,
        "value": "Индонезия"
    },
    {
        "isn": 9506,
        "value": "Иордания"
    },
    {
        "isn": 9507,
        "value": "Ирак"
    },
    {
        "isn": 9508,
        "value": "Иран"
    },
    {
        "isn": 9509,
        "value": "Ирландия"
    },
    {
        "isn": 9510,
        "value": "Исландия"
    },
    {
        "isn": 9511,
        "value": "Испания"
    },
    {
        "isn": 9512,
        "value": "Италия"
    },
    {
        "isn": 9513,
        "value": "Йемен"
    },
    {
        "isn": 9530,
        "value": "КНДР"
    },
    {
        "isn": 9514,
        "value": "Кабо-Верде"
    },
    {
        "isn": 9515,
        "value": "Казахстан"
    },
    {
        "isn": 9516,
        "value": "Камбоджа"
    },
    {
        "isn": 9517,
        "value": "Камерун"
    },
    {
        "isn": 9518,
        "value": "Канада"
    },
    {
        "isn": 9519,
        "value": "Катар"
    },
    {
        "isn": 9520,
        "value": "Кения"
    },
    {
        "isn": 9521,
        "value": "Кипр"
    },
    {
        "isn": 9522,
        "value": "Киргизия"
    },
    {
        "isn": 9523,
        "value": "Кирибати"
    },
    {
        "isn": 9524,
        "value": "Китай"
    },
    {
        "isn": 9525,
        "value": "Кокосовые (Киллинг) Острова"
    },
    {
        "isn": 9526,
        "value": "Колумбия"
    },
    {
        "isn": 9527,
        "value": "Коморы"
    },
    {
        "isn": 9528,
        "value": "Конго"
    },
    {
        "isn": 9529,
        "value": "Конго, Демократическая Республика"
    },
    {
        "isn": 9532,
        "value": "Коста-Рика"
    },
    {
        "isn": 9533,
        "value": "Кот Д'Ивуар"
    },
    {
        "isn": 9534,
        "value": "Куба"
    },
    {
        "isn": 9535,
        "value": "Кувейт"
    },
    {
        "isn": 222506,
        "value": "Кюрасао"
    },
    {
        "isn": 9536,
        "value": "Лаос"
    },
    {
        "isn": 9537,
        "value": "Латвия"
    },
    {
        "isn": 9538,
        "value": "Лесото"
    },
    {
        "isn": 9539,
        "value": "Либерия"
    },
    {
        "isn": 9540,
        "value": "Ливан"
    },
    {
        "isn": 9541,
        "value": "Ливия"
    },
    {
        "isn": 9542,
        "value": "Литва"
    },
    {
        "isn": 9543,
        "value": "Лихтенштейн"
    },
    {
        "isn": 226936,
        "value": "Луганская Народная Республика"
    },
    {
        "isn": 9544,
        "value": "Люксембург"
    },
    {
        "isn": 9566,
        "value": "МОНТСЕРРАТ"
    },
    {
        "isn": 9545,
        "value": "Маврикий"
    },
    {
        "isn": 9546,
        "value": "Мавритания"
    },
    {
        "isn": 9547,
        "value": "Мадагаскар"
    },
    {
        "isn": 9548,
        "value": "Майотто"
    },
    {
        "isn": 9549,
        "value": "Макао"
    },
    {
        "isn": 9550,
        "value": "Македония"
    },
    {
        "isn": 9551,
        "value": "Малави"
    },
    {
        "isn": 9552,
        "value": "Малайзия"
    },
    {
        "isn": 9553,
        "value": "Мали"
    },
    {
        "isn": 9554,
        "value": "Малые Тихоокеанские Острова США"
    },
    {
        "isn": 9555,
        "value": "Мальдивы"
    },
    {
        "isn": 9556,
        "value": "Мальта"
    },
    {
        "isn": 9557,
        "value": "Марокко"
    },
    {
        "isn": 9558,
        "value": "Мартиника"
    },
    {
        "isn": 9559,
        "value": "Маршалловы Острова"
    },
    {
        "isn": 9560,
        "value": "Мексика"
    },
    {
        "isn": 9561,
        "value": "Микронезия, Федеративные штаты"
    },
    {
        "isn": 9562,
        "value": "Мозамбик"
    },
    {
        "isn": 9563,
        "value": "Молдова"
    },
    {
        "isn": 9564,
        "value": "Монако"
    },
    {
        "isn": 9565,
        "value": "Монголия"
    },
    {
        "isn": 9567,
        "value": "Мьянма"
    },
    {
        "isn": 9568,
        "value": "Намибия"
    },
    {
        "isn": 9569,
        "value": "Науру"
    },
    {
        "isn": 9570,
        "value": "Непал"
    },
    {
        "isn": 9571,
        "value": "Нигер"
    },
    {
        "isn": 9572,
        "value": "Нигерия"
    },
    {
        "isn": 9573,
        "value": "Нидерландские Антилы"
    },
    {
        "isn": 9574,
        "value": "Нидерланды"
    },
    {
        "isn": 9575,
        "value": "Никарагуа"
    },
    {
        "isn": 9576,
        "value": "Ниуэ"
    },
    {
        "isn": 9577,
        "value": "Новая Зеландия"
    },
    {
        "isn": 9578,
        "value": "Новая Каледония"
    },
    {
        "isn": 9579,
        "value": "Норвегия"
    },
    {
        "isn": 9580,
        "value": "Объединенные Арабские Эмираты"
    },
    {
        "isn": 9581,
        "value": "Оман"
    },
    {
        "isn": 9585,
        "value": "Остров Буве"
    },
    {
        "isn": 222502,
        "value": "Остров Мэн"
    },
    {
        "isn": 9586,
        "value": "Остров Норфолк"
    },
    {
        "isn": 9587,
        "value": "Остров Рождества"
    },
    {
        "isn": 9588,
        "value": "Остров Херд и Острова Макдональд"
    },
    {
        "isn": 9582,
        "value": "Острова Кайман"
    },
    {
        "isn": 9583,
        "value": "Острова Кука"
    },
    {
        "isn": 9584,
        "value": "Острова Теркс и Кайкос"
    },
    {
        "isn": 9589,
        "value": "Пакистан"
    },
    {
        "isn": 9590,
        "value": "Палау"
    },
    {
        "isn": 9591,
        "value": "Палестина"
    },
    {
        "isn": 9592,
        "value": "Панама"
    },
    {
        "isn": 9594,
        "value": "Папуа-Новая Гвинея"
    },
    {
        "isn": 9595,
        "value": "Парагвай"
    },
    {
        "isn": 9596,
        "value": "Перу"
    },
    {
        "isn": 9597,
        "value": "Питкерн"
    },
    {
        "isn": 9598,
        "value": "Польша"
    },
    {
        "isn": 9599,
        "value": "Португалия"
    },
    {
        "isn": 9600,
        "value": "Пуэрто-Рико"
    },
    {
        "isn": 222500,
        "value": "Республика Абхазия"
    },
    {
        "isn": 222501,
        "value": "Республика Южная Осетия"
    },
    {
        "isn": 9601,
        "value": "Реюньон"
    },
    {
        "isn": 9602,
        "value": "Россия"
    },
    {
        "isn": 9603,
        "value": "Руанда"
    },
    {
        "isn": 9604,
        "value": "Румыния"
    },
    {
        "isn": 9624,
        "value": "США"
    },
    {
        "isn": 9605,
        "value": "Самоа"
    },
    {
        "isn": 9606,
        "value": "Сан-Марино"
    },
    {
        "isn": 9607,
        "value": "Сан-Томе и Принсипи"
    },
    {
        "isn": 9608,
        "value": "Саудовская Аравия"
    },
    {
        "isn": 9609,
        "value": "Свазиленд"
    },
    {
        "isn": 9610,
        "value": "Святая Елена, Остров Вознесения, Тристан-да-кунья"
    },
    {
        "isn": 9611,
        "value": "Северные Марианские Острова"
    },
    {
        "isn": 9612,
        "value": "Сейшелы"
    },
    {
        "isn": 222505,
        "value": "Сен-Бартельми"
    },
    {
        "isn": 222601,
        "value": "Сен-Мартен"
    },
    {
        "isn": 222602,
        "value": "Сен-Мартен (Нидерландская часть)"
    },
    {
        "isn": 9613,
        "value": "Сенегал"
    },
    {
        "isn": 9614,
        "value": "Сент-Винсент и Гренадины"
    },
    {
        "isn": 9615,
        "value": "Сент-Китс и Невис"
    },
    {
        "isn": 9616,
        "value": "Сент-Люсия"
    },
    {
        "isn": 9617,
        "value": "Сент-Пьер и Микелон"
    },
    {
        "isn": 212941,
        "value": "Сербия"
    },
    {
        "isn": 9619,
        "value": "Сингапур"
    },
    {
        "isn": 9620,
        "value": "Сирия"
    },
    {
        "isn": 9621,
        "value": "Словакия"
    },
    {
        "isn": 9622,
        "value": "Словения"
    },
    {
        "isn": 9625,
        "value": "Соломоновы Острова"
    },
    {
        "isn": 9626,
        "value": "Сомали"
    },
    {
        "isn": 9627,
        "value": "Судан"
    },
    {
        "isn": 9628,
        "value": "Суринам"
    },
    {
        "isn": 9629,
        "value": "Сьерра-Леоне"
    },
    {
        "isn": 9630,
        "value": "Таджикистан"
    },
    {
        "isn": 9631,
        "value": "Таиланд"
    },
    {
        "isn": 9632,
        "value": "Тайвань"
    },
    {
        "isn": 9633,
        "value": "Танзания"
    },
    {
        "isn": 9475,
        "value": "Тимор-Лесте"
    },
    {
        "isn": 9634,
        "value": "Того"
    },
    {
        "isn": 9635,
        "value": "Токелау"
    },
    {
        "isn": 9636,
        "value": "Тонга"
    },
    {
        "isn": 9637,
        "value": "Тринидад и Тобаго"
    },
    {
        "isn": 9638,
        "value": "Тувалу"
    },
    {
        "isn": 9639,
        "value": "Тунис"
    },
    {
        "isn": 9640,
        "value": "Туркмения"
    },
    {
        "isn": 9641,
        "value": "Турция"
    },
    {
        "isn": 9642,
        "value": "Уганда"
    },
    {
        "isn": 9643,
        "value": "Узбекистан"
    },
    {
        "isn": 9644,
        "value": "Украина"
    },
    {
        "isn": 9645,
        "value": "Уоллис и Футуна"
    },
    {
        "isn": 9646,
        "value": "Уругвай"
    },
    {
        "isn": 9647,
        "value": "Фарерские Острова"
    },
    {
        "isn": 9648,
        "value": "Фиджи"
    },
    {
        "isn": 9649,
        "value": "Филиппины"
    },
    {
        "isn": 9650,
        "value": "Финляндия"
    },
    {
        "isn": 9651,
        "value": "Фолклендские Острова (Мальвинские)"
    },
    {
        "isn": 9652,
        "value": "Франция"
    },
    {
        "isn": 9653,
        "value": "Французская Гвиана"
    },
    {
        "isn": 9654,
        "value": "Французская Полинезия"
    },
    {
        "isn": 9655,
        "value": "Французские Южные Территории"
    },
    {
        "isn": 9656,
        "value": "Хорватия"
    },
    {
        "isn": 9657,
        "value": "Центрально-Африканская Республика"
    },
    {
        "isn": 9658,
        "value": "Чад"
    },
    {
        "isn": 212931,
        "value": "Черногория"
    },
    {
        "isn": 9659,
        "value": "Чехия"
    },
    {
        "isn": 9660,
        "value": "Чили"
    },
    {
        "isn": 9661,
        "value": "Швейцария"
    },
    {
        "isn": 9662,
        "value": "Швеция"
    },
    {
        "isn": 9663,
        "value": "Шпицберген и Ян Майен"
    },
    {
        "isn": 9664,
        "value": "Шри-Ланка"
    },
    {
        "isn": 9665,
        "value": "Эквадор"
    },
    {
        "isn": 9666,
        "value": "Экваториальная Гвинея"
    },
    {
        "isn": 9667,
        "value": "Эландские Острова"
    },
    {
        "isn": 9668,
        "value": "Эль-Сальвадор"
    },
    {
        "isn": 9669,
        "value": "Эритрея"
    },
    {
        "isn": 9670,
        "value": "Эстония"
    },
    {
        "isn": 9671,
        "value": "Эфиопия"
    },
    {
        "isn": 9672,
        "value": "Южная Африка"
    },
    {
        "isn": 9531,
        "value": "Южная Корея"
    },
    {
        "isn": 9673,
        "value": "Южные Джорджия и Сандвичевы Острова"
    },
    {
        "isn": 222603,
        "value": "Южный Судан"
    },
    {
        "isn": 9674,
        "value": "Ямайка"
    },
    {
        "isn": 9675,
        "value": "Япония"
    }
]

export default KIAS_COUNTRIES